var React = require('react');

function PaymentInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("rect",{"x":"1","y":"4","width":"22","height":"16","rx":"2","key":0}),React.createElement("path",{"d":"M2 9h20m-6 6h3","key":1})]));
}

PaymentInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = PaymentInline;

PaymentInline.default = PaymentInline;
